import { css } from '@emotion/css'
import { spacing, fontWeight, borderRadius } from '../../styles'
import { shorthandHelper } from '../../styles/helpers'
import subHeadingStyles from '../../typography/Subheading/styles'
import { colors } from '../../themes'

const styles = {
  wrapper: css({
    flexDirection: 'column',
  }),

  toggle: css({
    boxSizing: 'border-box',
    cursor: 'pointer',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontWeight: fontWeight.semiBold,
    backgroundColor: colors.porcelain,
    padding: shorthandHelper([spacing.default, spacing.medium]),
    userSelect: 'none',
    borderTopLeftRadius: borderRadius.default,
    borderTopRightRadius: borderRadius.default,
    border: 'none',

    [`&:focus .${subHeadingStyles.wrapper}`]: {
      outline: 'none',
      textDecoration: 'underline',
    },
  }),

  icon: css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }),

  body: css({
    padding: spacing.medium,
  }),
}

export default styles
